import { create } from 'zustand';
import { FileUtils } from '@shared/utils';
import { ApiUtils, ResourcesApi } from '@shared/api';

interface UseDownloadResourceStore {
  loading: boolean;
  error: string | null;
  downloadResource: (params: { id: string; filename: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadResourceStore = create<UseDownloadResourceStore>((set) => ({
  loading: false,
  error: null,

  downloadResource: async (params, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ResourcesApi.downloadFile(params.id, signal);
      FileUtils.downloadFile(result, params.filename);
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, error: null }),
}));
